import { FEATURE_FLAGS } from '@/utils/constants'

export default (label: string) => {
	const includes = FEATURE_FLAGS.includes(label)
	return includes
}
